// Coaches who can no longer be impersonated in chat. Filtered out of the
// "send messages as" dropdown in both the shared chat (web/apollo) and pulse.
export const BLOCKED_IMPERSONATION_COACH_IDS: ReadonlySet<string> = new Set([
  "40366ee8-9256-4209-8e08-477662e129c9", // Sarah Ryan (Iconic)
  "ed527ab7-e855-4791-860b-5da649de4874", // Courteney Fisher (EMPWR)
  "6d7b7376-5e11-40df-b81c-c42c02600cc8", // Nairee Kiana (Thrive)
]);

export function isImpersonationBlocked(userId: string | null | undefined): boolean {
  return !!userId && BLOCKED_IMPERSONATION_COACH_IDS.has(userId);
}
